export default function chooseModel(paramData) {
    const searchData = {
        module: paramData.module,
        record: paramData.id,
        relName: 'acm_license_model_aon_list_of_models_1',
        rightPanel: false,
        subpanel: 'aon_list_of_models',
    };
    this.rest.fetchData('returnSubpanelData', 'POST', searchData).then((returnData) => {
        const options = [];
        returnData.data.records.forEach((record) => {
            options.push({value: record.id, label: record.name});
        });

        this.popup('chooseModel', {
            params: {
                way: paramData.way,
                module: paramData.module,
                id: paramData.id,
                opt: options,
            },
            header: this.translate('LBL_CHOOSE_MODEL', paramData.module),
        });
    });
}
